export default __webpack_public_path__ + "static/media/image_unavailable.f01a15f9.jpg";